import { TextField } from "@mui/material";
import React from "react";

export const UnderlinedInput = (props) => (
  <TextField
    sx={{
      width: "170px",
      height: "50px",
      "& .MuiInput-root:before": {
        borderBottom: "1px solid rgba(255, 255, 255, 0.75)",
      },
      "& .MuiInput-root:after": {
        borderBottom: "2px solid white",
      },
      "& .MuiInput-root:hover:not(.Mui-disabled):before": {
        borderBottom: "2px solid rgba(255, 255, 255, 0.85)",
      },
      "& .MuiInput-root.Mui-error:after, & .MuiInput-root.Mui-error.Mui-focused:after":
        {
          borderBottom: "2px solid orange",
        },
      "& .MuiInput-root.Mui-error:before": {
        borderBottom: "1px solid orange",
      },
      "& .MuiInputBase-input": {
        caretColor: "white",
        color: "white",
        fontSize: 30,
        fontFamily: '"proxima-nova", "sans-serif"',
        fontWeight: "bold",
      },
      "& .MuiInputBase-input::placeholder": {
        color: "white",
        opacity: 0.75,
        fontSize: 32,
        fontFamily: '"proxima-nova", "sans-serif"',
        position: "relative",
        top: 0,
      },
      "& .MuiFormHelperText-root.Mui-error": {
        color: "orange",
        fontWeight: "bold",
      },
    }}
    variant="standard"
    {...props}
    inputProps={{
      ...props.inputProps,
    }}
  />
);
